<template>
    <div class="view">

        <Head @ck="menuOpen = true">{{til}}</Head>
        <router-view></router-view>
    </div>
</template>

<script>
import mainDelegate from '@/delegate/mainDelegate'
export default {
    name: 'MyTest',
    mixins: [mainDelegate],
    computed:{
        til(){
            return this.$route.name==='mytest'?this.$t("menu.myTest"):this.$t("menu.classTest")
        }
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';
@import 'view.less';
</style>



// WEBPACK FOOTER //
// src/page/MyTest.vue